import { Container, Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import AAAI from '@/assets/images/shared/logos/aaai.png';
import AAMAS from '@/assets/images/shared/logos/aamas.png';
import AAPT from '@/assets/images/shared/logos/aapt.png';
import ACL from '@/assets/images/shared/logos/acl.png';
import AMA from '@/assets/images/shared/logos/ama.png';
import CES from '@/assets/images/shared/logos/ces.png';
import COG from '@/assets/images/shared/logos/cog.png';
import EURAI from '@/assets/images/shared/logos/eurai.png';
import IEDM from '@/assets/images/shared/logos/iedm.png';
import IEEE from '@/assets/images/shared/logos/ieee.png';
import IPSO from '@/assets/images/shared/logos/ipso.png';
import MRS from '@/assets/images/shared/logos/mrs.png';
import SEAL from '@/assets/images/shared/logos/seal.png';
import SEB from '@/assets/images/shared/logos/seb.png';
import UCLA from '@/assets/images/shared/logos/ucla.png';

export const UNDERLINE_PARTNERS_ID = 'underline-partners';

export const PresentationPartners: FC = () => {
  const { t } = useTranslation();

  return (
    <Container id={UNDERLINE_PARTNERS_ID}>
      <Text mt={6} fontSize="2xl" textAlign="center" fontFamily="heading" fontWeight="bold">
        {t('newEventPage.trustedBy')}
      </Text>
      <Flex
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        columnGap={{ base: 10, lg: 24 }}
        rowGap={12}
        mt={8}
      >
        <Image src={AAAI} alt="AAAI" />
        <Image src={IEDM} alt="IEDM" />
        <Image src={AAPT} alt="AAPT" />
        <Image src={ACL} alt="ACL" />
        <Image src={UCLA} alt="UCLA" />
        <Image src={MRS} alt="MRS" />
        <Image src={COG} alt="COG" />
        <Image src={AAMAS} alt="AAMAS" />
        <Image src={IPSO} alt="IPSO" />
        <Image src={CES} alt="CES" />
        <Image src={IEEE} alt="IEEE" />
        <Image src={SEB} alt="SEB" />
        <Image src={AMA} alt="AMA" />
        <Image src={EURAI} alt="EURAI" />
        <Image src={SEAL} alt="SEAL" />
      </Flex>
    </Container>
  );
};
